<style lang="less" scoped>
.autopage{
  // width: 1920px;
  // height:1080px;
  width: 100%;
  height:100%;
  overflow: hidden;
  background-size: 100% 100%;
}
.autocontainer {
  width: 1920px;
  height: 1080px;
  margin: 0px;
  border: 0px;
  background: none;
  overflow: hidden;
}
</style>
<template>
  <div class="autopage">
    <iframe class='autocontainer' :style="{'transform':this.styletext}" src="/loginhtml"></iframe>
    <!-- <iframe class='autocontainer' :style="{'transform':this.styletext}" src="https://post.deweicloud.com/login"></iframe> -->
  </div>
</template>

<script>

export default {
  name: "index",
  data() {
    return {
      //缩放大小
      scaledx:1,
      //横向缩放
      scalewdx:1,
      //从向缩放
      scalehdx:1,
      //左右偏移
      scxw:0,
      // 上下偏移
      scyw:0,
      //样式拼接
      styletext:'scale(1)',
    };
  },

  methods: {

  },
  mounted() {
    let setIntervaltime=setInterval(() => {
      if(window.localStorage.getItem('htttpUrl')){
        if(window.localStorage.getItem('htttpUrl')!=this.$route.fullPath){
          clearInterval(setIntervaltime);
          this.$router.push({ path: window.localStorage.getItem('htttpUrl')});
        }
      }else{
        window.localStorage["htttpUrl"]='/login'
      }

    }, 10);

    this.scalewdx = window.innerWidth / 1920;
    this.scalehdx = window.innerHeight / 1080;
    this.scaledx = this.scalewdx < this.scalehdx ? this.scalewdx : this.scalewdx > this.scalehdx ? this.scalehdx : 1

    /***居中 */
    // this.scxw = (960 - window.innerWidth / 2) / (1920 * this.scaledx) * 100
    // this.scyw = (540 - window.innerHeight / 2) / (1080 * this.scaledx) * 100
    /***拉伸 */
    this.scxw = (960 - window.innerWidth / 2) / (1920 * this.scalewdx) * 100
    this.scyw = (540 - window.innerHeight / 2) / (1080 * this.scalehdx) * 100
    // console.log('innerHeight',window.innerHeight)
    //     console.log('innerWidth',window.innerWidth)
    //
    // console.log('scyw', this.scyw);
    // console.log('scxw', this.scxw);
    // console.log('scaledx', this.scaledx);
    /***居中 */
    // this.styletext='scale(' + this.scaledx + ') translate(-' + this.scxw + '%,-' + this.scyw + '%)'
    /***拉伸 */
    this.styletext='scale('+this.scalewdx+','+this.scalehdx+') translate(-' + this.scxw + '%,-' + this.scyw + '%)'
    window.onresize = ()=> {
      this.scalewdx = window.innerWidth / 1920;
      this.scalehdx = window.innerHeight / 1080;
      this.scaledx = this.scalewdx < this.scalehdx ? this.scalewdx : this.scalewdx > this.scalehdx ? this.scalehdx : 1
      /***居中 */
      // this.scxw = (960 - window.innerWidth / 2) / (1920 * this.scaledx) * 100
      // this.scyw = (540 - window.innerHeight / 2) / (1080 * this.scaledx) * 100
      /***拉伸 */
      this.scxw = (960 - window.innerWidth / 2) / (1920 * this.scalewdx) * 100
      this.scyw = (540 - window.innerHeight / 2) / (1080 * this.scalehdx) * 100
      /***居中 */
      // this.styletext='scale(' + this.scaledx + ') translate(-' + this.scxw + '%,-' + this.scyw + '%)'
      /***拉伸 */
      this.styletext='scale('+this.scalewdx+','+this.scalehdx+') translate(-' + this.scxw + '%,-' + this.scyw + '%)'

    }
  }
};
</script>





// WEBPACK FOOTER //
// src/views/login.vue